var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSql = function SvgSql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15642",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.7 14.75c.138-1.164 1.894-1.373 2.722-.737.408.33-.024.851-.384.587-.444-.281-1.452-.413-1.578.21-.162.983 2.448.42 2.405 2.016-.042 1.523-2.249 1.558-3.077.875a.443.443 0 0 1-.083-.588c.155-.155.33-.21.533-.041.492.335 1.758.587 1.848-.265-.078-.887-2.572-.354-2.386-2.057M12.545 17.317l.096.113c.395.36-.12.948-.522.57l-.203-.161c-.312.215-.678.318-1.164.318-1.055 0-2.261-.727-2.261-2.202s1.2-2.225 2.261-2.225c1.115 0 2.207.75 2.207 2.225 0 .57-.145.99-.414 1.362m-.361-1.362c0-.953-.75-1.439-1.432-1.439-.738 0-1.464.485-1.464 1.439 0 .726.617 1.416 1.463 1.416.216 0 .426-.054.636-.108l-.684-.63c-.317-.384.187-.93.588-.576l.678.677c.149-.21.215-.467.215-.78M13.842 14.21c0-.198.168-.366.378-.366.192 0 .354.169.354.366v3.005h1.632c.587 0 .6.785 0 .785H14.22c-.21 0-.378-.15-.378-.365z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default SvgSql;